import FeatureGates from '@atlaskit/feature-gate-js-client';

export const getExperimentValue = (
	experimentKey: string,
	defaultCohort: string,
	fireExperimentExposure?: boolean,
): string => {
	if (FeatureGates.initializeCalled()) {
		return FeatureGates.getExperimentValue(experimentKey, 'cohort', defaultCohort, {
			fireExperimentExposure,
		});
	}

	return defaultCohort;
};

export const getTargetingGate = (experimentKey: string): boolean =>
	FeatureGates.initializeCompleted() && FeatureGates.checkGate(experimentKey);
